// extracted by mini-css-extract-plugin
export default {"login":"calculate_login__3g-Nb","searchbox":"calculate_searchbox__cMxK-","date":"calculate_date__yMay5","total":"calculate_total__06mzv","reset_btn":"calculate_reset_btn__gUI0i"};